export default "__VITE_ASSET__WDiI7xNc__"